import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import LocationHeader from "../components/main/LocationHeader";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ScrollNavbar from "../components/ScrollNavbar";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import LocationComponent from "../components/main/LocationComponent";
import MeetExpertsComponent from "../components/main/MeetExpertsComponent";
import HowFt from "../components/HowFt";
import LocationFaqComponent from "../components/main/LocationFaqComponent";
import NavTop from "../components/NavTop";
import OurLocation from "../components/OurLocation";
import PopupOffer from "../components/PopupOffer";
import LocationContentGreaterNoida from "../components/main/LocationContentGreaterNoida";
import GroomingFormComponent from "../components/form/GroomingFormComponent";
import LocationGroomingPackageComponent from "../components/LocationGroomingPackageComponent";

const GreaterNoidaPage = () => {

  const [openForm, setOpenForm] = useState(false);

  const [offerPopup, setOfferPopup] = useState(false);

      const [petGroom, setPetGroom] = useState("Dog")
  

  useEffect( () => {

    const timer = setTimeout( () => {
      setOfferPopup(true)
    }, 15000)

    return () => clearInterval(timer)

  },[])
  
  

  const headerData = {
    heading: "Premium Pet Grooming at Home in Greater Noida",
    text: "Same Day Booking - Smart Choice for Greater Noida Pet Parents.",
  };

  const faqData = {
    heading: "",
    data: [
      {
          question: "How does at-home grooming work?",
          text: ["Our certified groomers arrive at your doorstep with portable equipment (sanitized before every visit). All services are performed in your pet’s familiar environment—whether it’s your apartment (Alpha/Beta sectors), farmhouse, or hostel near universities."],
          points: [],
        },
      {
          question: "What areas do you cover in Greater Noida?",
          text: ['We serve all sectors (Alpha to Delta), Noida Extension, Knowledge Park, Tech Zone, and surrounding villages/farmhouses. To confirm coverage, WhatsApp us your exact location (e.g., "Gaur City Tower 5").'],
          points: [],
        },
      {
          question: "How do I book a same-day slot?",
          text: [""],
          points: [

'Call/WhatsApp: 96581 89189 (mention "GREATER" for ₹300 OFF first booking).',
'Urgent slots: Mobile vans reach within 2 hours in Pari Chowk, Gamma, and Delta sectors.',

            
          ],
        },
      {
          question: "Why choose home grooming over salon visits?",
          text: [""],
          points: [

"Zero stress: No car rides or noisy salon environments.",
"Monsoon-ready: Special anti-tick/flea treatments for Greater Noida’s humid weather.",
"Farmhouse-friendly: We handle large breeds (Great Danes, St. Bernards) outdoors.",

            
          ],
        },
      {
          question: "What’s included in the ₹849 Basic Grooming?",
          text: [""],
          points: [

'Dust-proof bath (ideal for construction-heavy zones like Noida Extension).',
'Nail trim + ear cleaning.',
'Light de-shedding (extra charge for heavy shedders like Huskies).',

            
          ],
        },
      {
          question: "Do you groom cats?",
          text: ["Absolutely! We specialize in stress-free cat grooming:"],
          points: [

"Lion cuts for Persian cats (in their own space).",
"Gentle nail care (no car rides needed).",
"Quiet brushing sessions (ideal for shy cats in apartments).",

            
          ],
        },
      {
          question: "Are your groomers trained for specific breeds?",
          text: ["Yes! Our team handles:"],
          points: [

            "Golden Retrievers/Pugs (common in Gaur City).",
            "Indie dogs (with extra patience).",
            "Exotic breeds (Persians, Maine Coons) with breed-specific techniques.",

            
          ],
        },
      {
          question: "What safety measures do you follow?",
          text: [""],
          points: [

"Sanitized kits: Tools disinfected after every pet.",
"Certified groomers: Trained in pet first aid.",
"No sedation: 100% gentle handling.",

            
          ],
        },
      {
          question: "Any discounts for students/university staff?",
          text: ["Yes! 10% OFF for students/staff of Shiv Nadar, GIMS, or Amity—share your ID card photo while booking."],
          points: [],
        },
      {
          question: "What if my pet gets anxious?",
          text: ["We use calming techniques (treats, breaks) and advise pre-grooming tips (e.g., fasting for 2 hours if needed)."],
          points: [],
        },
      {
          question: "Monsoon special services?",
          text: [""],
          points: [

"Anti-tick packages (June-Sept).",
"Paw waxing for muddy farmhouse paws.",
"Emergency de-matting for long-haired pets.",

            
          ],
        },
      {
          question: "Can I reschedule/cancel?",
          text: [""],
          points: [

"Free rescheduling before 6 hours.",
"Rainy-day policy: No charges for monsoon-related cancellations.",

            
          ],
        },
      
    ],
  };

  const locationData = {
    data: [

      "Sector Alpha I & II",
      "Sector Beta I & II",
      "Sector Gamma I, II & III",
      "Sector Delta I, II, III & IV",
      "Sector ETA I & II",
      "Sector MU I & II",
      "Sector Omicron I, II, III",
      "Sector Pi I & II",
      "Sector Sigma I & II",
      "Sector Chi I to Chi V",
      "Sector Zeta I & II",
      "Tech Zone IV & VII",
      "Knowledge Park I, II, III, V",
      "Greater Noida West (Noida Extension)",
      "Pari Chowk",
      "Surajpur",
      "Kasna",
      "Dadri",
      "Ecotech I, II, III",
      "UPSIDC Industrial Area",
      "Sectors 18–25, Yamuna Expressway",
      "YEIDA City (Yamuna Authority Area)",
      "Eastern Peripheral Expressway Belt",
      "Jewar Airport Zone",
      "Yamuna Expressway Corridor",
      "Greater Noida West Expansion Zone",
      
      
    ],
  };

  
  const schema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "FluffyTouch – At-Home Pet Grooming Greater Noida",
  "image": "https://fluffytouch.in/static/media/grooming-haircut.2be3674bb25b2f36628d.jpg",
  "@id": "https://fluffytouch.in/pet-grooming-at-home/greater-noida",
  "url": "https://fluffytouch.in/pet-grooming-at-home/greater-noida",
  "telephone": "+91-96581-89189",
  "priceRange": "₹849–₹1499",
  "description": "Premium at-home pet grooming services in Greater Noida. Certified groomers provide personalized grooming for dogs and cats at your doorstep.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Greater Noida",
    "addressRegion": "Uttar Pradesh",
    "postalCode": "201310",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 28.4744,
    "longitude": 77.5030
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
      ],
      "opens": "07:00",
      "closes": "21:00"
    }
  ],
  "areaServed": [
    { "@type": "Place", "name": "Sector Alpha I & II" },
    { "@type": "Place", "name": "Sector Beta I & II" },
    { "@type": "Place", "name": "Gamma, Delta, Chi, Zeta, Knowledge Park, Tech Zone, Greater Noida West" },
    { "@type": "Place", "name": "Pari Chowk, Surajpur, Kasna, Dadri, YEIDA City, Yamuna Expressway" }
  ],
  "makesOffer": [
    {
      "@type": "Offer",
      "name": "Basic Grooming Package",
      "price": "849",
      "priceCurrency": "INR",
      "description": "Includes bath, nail trim, ear cleaning, and light de-shedding."
    },
    {
      "@type": "Offer",
      "name": "Premium Spa Package",
      "price": "1499",
      "priceCurrency": "INR",
      "description": "Breed-specific haircut, blueberry facial, pawdicure, and teeth brushing."
    },
    {
      "@type": "Offer",
      "name": "Farmhouse Special",
      "price": "Contact for pricing",
      "priceCurrency": "INR",
      "description": "Special for large breeds with outdoor setup and de-matting."
    }
  ],
  "sameAs": [
    "https://www.facebook.com/fluffytouch",
    "https://www.instagram.com/fluffytouch",
    "https://www.linkedin.com/company/fluffytouch"
  ],
  "additionalType": "https://schema.org/PetGrooming"
  };

  return (
    <div>
      <div className="greater-noida-page">
        <Helmet>
          <title>
            🐾 Pet Grooming at Home in Greater Noida | FluffyTouch Premium Spa
          </title>
          <meta
            name="description"
            content="Book expert at-home pet grooming in Greater Noida! Serving Alpha/Beta sectors, Knowledge Park & farmhouses. Same-day slots, 30% OFF first booking - Call now!"
          />

           <script type="application/ld+json">{JSON.stringify(schema)}</script>
          
        </Helmet>

        {openForm ? <GroomingFormComponent setDynamicForm={setOpenForm} /> : ""}
        {offerPopup ? <PopupOffer open={setOfferPopup} /> : ""}

        <ScrollNavbar />

        <NavTop />
        <Nav />

        <LocationHeader
          heading={headerData.heading}
          text={headerData.text}
          form={setOpenForm}
          setPetGroom={setPetGroom}
        />

        <NumberIncrement />

        <ExploreGroomingService />

                <LocationGroomingPackageComponent petGroom={petGroom} setPetGroom={setPetGroom} />


        <LocationComponent location="Greater Noida" data={locationData.data} />
        <MeetExpertsComponent form={setOfferPopup} />

        <HowFt />

        <LocationContentGreaterNoida />
 
        <OurLocation />

        <LocationFaqComponent data={faqData.data} />

        <Footer />
      </div>
    </div>
  );
};

export default GreaterNoidaPage;
